import React, { useEffect, useState } from "react";
import { Col, Row, Spin } from "antd";
import { useSelector } from "react-redux";
import { IoCallOutline } from "react-icons/io5";
import { LuMessagesSquare } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";
import { IoShareSocialOutline } from "react-icons/io5";
import { LiaAndroid } from "react-icons/lia";
import { AiOutlineApple } from "react-icons/ai";

const Metrics = ({ loading }) => {
  const metrics = useSelector((state) => state.metrics.data);

  const metricItems = [
    {
      name: "Call Made",
      total: metrics?.callResponse || 0,
      icon: <IoCallOutline size={25} color="var(--mainBlue)" />,
    },
    {
      name: "Sms Sent",
      total: metrics?.smsResponse || 0,
      icon: <LuMessagesSquare size={25} color="var(--mainBlue)" />,
    },
    {
      name: "Email Sent",
      total: metrics?.emailResponse || 0,
      icon: <MdOutlineEmail size={25} color="var(--mainBlue)" />,
    },
    {
      name: "Sharing Statistics",
      total: metrics?.shareResponse || 0,
      icon: <IoShareSocialOutline size={25} color="var(--mainBlue)" />,
    },
    {
      name: "Unique Visitor (Android)",
      total: metrics?.androidResponse || 0,
      icon: <LiaAndroid size={25} color="var(--mainBlue)" />,
    },
    {
      name: "Unique Visitor (iOS)",
      total: metrics?.iosResponse || 0,
      icon: <AiOutlineApple size={25} color="var(--mainBlue)" />,
    },
  ];

  const formatNumber = (number) => {
    const formattedNumber = new Intl.NumberFormat().format(number);
    if (number < 10) {
      return `0${formattedNumber}`;
    }
    return formattedNumber;
  };

  return (
    <Row gutter={[30, 30]}>
      {metricItems?.map((v, i) => (
        <Col key={i} xs={24} sm={12} md={8}>
          <div className="analytic_box">
            {v.icon}
            <p>{v.name}</p>
            {loading ? (
              <div>
                <Spin />
              </div>
            ) : (
              <p style={{ fontSize: "18px" }}>
                <strong>{formatNumber(v.total)}</strong>
              </p>
            )}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default Metrics;
